import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M20.14 23H3.86A2.86 2.86 0 0 1 1 20.14V3.86A2.86 2.86 0 0 1 3.86 1h16.28A2.86 2.86 0 0 1 23 3.86v16.28A2.86 2.86 0 0 1 20.14 23"
            fill="#E80200"
        />
        <path
            d="M18.38 10.515a4.56 4.56 0 0 0-4.565-4.565H6.28v12.1h3.08v-2.97h3.693l2.027 2.97h3.3l-2.404-3.512a4.58 4.58 0 0 0 2.404-4.023M13.815 12H9.36V9.03h4.455c.817 0 1.485.668 1.485 1.485S14.632 12 13.815 12"
            fill="white"
        />
    </svg>
));
RabotaByBrandSize24Glyph.displayName = 'RabotaByBrandSize24Glyph';
